import React from 'react';

import {
  Box,
  Button,
  FormControl,
  GridLegacy as Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';

import { BooleanFilter, RateCodeSearchState } from './RateCodeGridConfig';

interface Props {
  searchFields: RateCodeSearchState;
  onSearchFieldsChange: React.Dispatch<React.SetStateAction<RateCodeSearchState>>;
  onSearch: () => void;
  isSearching: boolean;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

export default function RateCodeSearchForm({
  searchFields,
  onSearchFieldsChange,
  onSearch,
  isSearching,
  onKeyDown,
}: Props) {
  return (
    <Box sx={{ pt: 1 }}>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Rate Code"
            size="small"
            value={searchFields.rateCode}
            onChange={(e) => onSearchFieldsChange((prev) => ({ ...prev, rateCode: e.target.value }))}
            onKeyDown={onKeyDown}
            placeholder="Search by code (e.g. FLASH24)"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Flash</InputLabel>
            <Select
              label="Flash"
              value={searchFields.isFlash}
              onChange={(e) => onSearchFieldsChange((prev) => ({ ...prev, isFlash: e.target.value as BooleanFilter }))}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Yes</MenuItem>
              <MenuItem value="false">No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Net Rate</InputLabel>
            <Select
              label="Net Rate"
              value={searchFields.isNetRate}
              onChange={(e) =>
                onSearchFieldsChange((prev) => ({ ...prev, isNetRate: e.target.value as BooleanFilter }))
              }
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="true">Yes</MenuItem>
              <MenuItem value="false">No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Stack direction="row" sx={{ mb: 2 }}>
        <Button variant="contained" onClick={onSearch} disabled={isSearching}>
          Search
        </Button>
      </Stack>
    </Box>
  );
}
